export function directusImg (filename: string, preset?: 'bitbeli-sm' | 'bitbeli-md' | 'bitbeli-lg' | 'og' | 'twitter') {
  const { directusUrl } = useRuntimeConfig().public

  return `${directusUrl}/assets/${filename}${preset ? '?key=' + preset : ''}`
}
